import GokuDataGrid from '@/components/GokuDataGrid'
import { getServiceAnalyticUsages } from '@/modules/Service/services'
import { Service } from '@/modules/Service/types'
import React from 'react'
import { columns } from './column'

interface DomainsProps {
    service: Service
}
const Domains: React.FC<DomainsProps> = ({ service }) => {
    return (
        <GokuDataGrid
            columns={columns}
            reactQueryKey={`services.analytics.${service?.service_creatable_uuid}.vnis`}
            apiCall={async () => {
                return {
                    results: await getServiceAnalyticUsages({
                        serviceID: service?.service_id,
                        params: {
                            type: '/domains',
                        },
                    }),
                }
            }}
            options={{
                title: undefined,
                pageSize: 5,
            }}
            paginationMode="client"
            dataGridProps={{
                getRowId: (row) => {
                    return row?.domain
                },
            }}
        />
    )
}

export default Domains
